import { CacheableRolodexEntryJson } from 'types/rolodex/rolodexCache'
import { RolodexEntryType } from 'types/rolodex/rolodexEntries'

import { GeckoEntryBase } from './geckoEntry'

export type FlightSetType = 'day-rgb' | 'day-ir' | 'night-ir'

export interface RooftopFlightDataData {
  component_id: string
  flight_set_type: FlightSetType
  weather_type: string
  upload_date: string
  total_photos: number
  uploaded_photos: string[]
  metadata?: Record<string, unknown>
  [key: string]: unknown
}

export interface RooftopFlightDataTags {
  asset?: string
  component?: string
  organization?: string
  site?: string
}

export class GeckoRooftopFlightData extends GeckoEntryBase<
  RooftopFlightDataData,
  RooftopFlightDataTags
> {
  static fromJSON(json: CacheableRolodexEntryJson): GeckoRooftopFlightData {
    return new GeckoRooftopFlightData(
      json,
      json.data as RooftopFlightDataData,
      json.tags as RooftopFlightDataTags,
      json.index
    )
  }

  constructor(
    json: CacheableRolodexEntryJson,
    data: RooftopFlightDataData,
    tags: RooftopFlightDataTags,
    index: Record<string, string>
  ) {
    super(json, data, tags, index)
    if (json.type !== RolodexEntryType.ROOFTOP_FLIGHT_DATA) {
      throw new Error(
        `Invalid entry type: expected ${RolodexEntryType.ROOFTOP_FLIGHT_DATA}, got ${json.type}`
      )
    }
  }
}
